<template>
  <section id="skills" class="section">
    <div class="content-670">
      <h2 class="title">HABILIDADES</h2>
      <div class="section-des">El conocimiento adquirido atreves de los años y las experiencias.</div>
      <p>Línea de tiempo en la cual te mostrarte, en que empresas he tenido la gran oportunidad de trabajar, crear y/o aportar soluciones tecnológicas en diversas dificultades, proyecto áreas.</p>
    </div>
    <ul class="skills-progress">

      <li>
        <span class="name">FRONT-END</span>
        <div class="skill">
          <div class="skill-fill" data-fill="70%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo01_css3.png" alt="Habilidad Css3" title="CSS3" />
          <img src="@/assets/images/logos/logo01_html5.png" alt="Habilidad Html5" title="HTML5" />
          <img src="@/assets/images/logos/logo01_js.png" alt="Habilidad Js" title="JS" />
          <img src="@/assets/images/logos/logo01_less.png" alt="Habilidad Less" title="LESS" />
          <img src="@/assets/images/logos/logo01_sass.png" alt="Habilidad Sass" title="SASS" />
        </div>
      </li>

      <li>
        <span class="name">BACk-END</span>
        <div class="skill">
          <div class="skill-fill" data-fill="80%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo02_php.png" alt="Habilidad Php" title="PHP" />
          <img src="@/assets/images/logos/logo02_vuejs.png" alt="Habilidad Vue" title="VUEjs" />
          <img src="@/assets/images/logos/logo02_angular.png" alt="Habilidad Angular" title="Angular"/>
          <img src="@/assets/images/logos/logo02_ruby.png" alt="Habilidad Ruby" title="Ruby"/>
        </div>
      </li>

      <li>
        <span class="name">DATABASE</span>
        <div class="skill">
          <div class="skill-fill" data-fill="80%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo03_mongodb.png" alt="Habilidad MongoDB" title="MongoDB"/>
          <img src="@/assets/images/logos/logo03_postgresql.png" alt="Habilidad PostgreSQL" title="PostgreSQL" />
          <img src="@/assets/images/logos/logo03_sqlite.png" alt="Habilidad SQLite" title="SQLite" />
          <img src="@/assets/images/logos/logo03_mysql.png" alt="Habilidad MySQL" title="MySQL" />
        </div>
      </li>

      <li>
        <span class="name">NATIVE APPs</span>
        <div class="skill">
          <div class="skill-fill" data-fill="50%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo04_android.png" alt="Habilidad Android" title="Android"/>
          <img src="@/assets/images/logos/logo04_switch.png" alt="Habilidad Switch" title="Switch" />
        </div>
      </li>

      <li>
        <span class="name">HYBRID APPs</span>
        <div class="skill">
          <div class="skill-fill" data-fill="60%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo05_react_native.png" alt="Habilidad React Native" title="React Native" />
          <img src="@/assets/images/logos/logo05_ionic.png" alt="Habilidad ionic" title="Ionic" />
          <img src="@/assets/images/logos/logo05_flutter.png" alt="Habilidad Flutter" title="Flutter"/>
        </div>
      </li>

      <li>
        <span class="name">High-Level Developer</span>
        <div class="skill">
          <div class="skill-fill" data-fill="80%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo02_php.png" alt="Habilidad Php" title="Php" />
          <img src="@/assets/images/logos/logo02_java.png" alt="Habilidad Java" title="Java" />
        </div>
      </li>

      <li>
        <span class="name">Low-Level Developer</span>
        <div class="skill">
          <div class="skill-fill" data-fill="40%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo02_python.png" alt="Habilidad Python" title="Python"/>
          <img src="@/assets/images/logos/logo02_r.png" alt="Habilidad R" title="R"/>
          <img src="@/assets/images/logos/logo02_go.png" alt="Habilidad Go" title="Go!"/>
        </div>
      </li>

      <li>
        <span class="name">DEVOPS</span>
        <div class="skill">
          <div class="skill-fill" data-fill="90%"></div>
        </div>
        <div class="logos">
          <img src="@/assets/images/logos/logo00_whmcs.png" alt="Habilidad Whmcs" title="Whcm" />
          <img src="@/assets/images/logos/logo00_basecamp.png" alt="Habilidad BaseCamp" title="BaseCamp" />
          <img src="@/assets/images/logos/logo00_trello.png" alt="Habilidad Trello" title="Trello" />
          <img src="@/assets/images/logos/logo00_slack_hash.png" alt="Habilidad Slack" title="Slack" />
          <img src="@/assets/images/logos/logo00_gulp.png" alt="Habilidad Gulp" title="Gulp" />

          <img src="@/assets/images/logos/logo00_jira.png" alt="Habilidad Jira" title="Jira" />
          <img src="@/assets/images/logos/logo00_gitlab.png" alt="Habilidad GitLab" title="GitLab" />
          <img src="@/assets/images/logos/logo00_git.png" alt="Habilidad Git" title="Git" />
          <img src="@/assets/images/logos/logo00_bitbucket.png" alt="Habilidad Bitbucket" title="Bitbucket" />
          <img src="@/assets/images/logos/logo00_dev.png" alt="Habilidad Dev" title="DEV" />
          <img src="@/assets/images/logos/logo00_docker.png" alt="Habilidad Docker" title="Docker" />

          <img src="@/assets/images/logos/logo00_apache.png" alt="Habilidad Apache" title="Apache" />
          <img src="@/assets/images/logos/logo00_nginx.png" alt="Habilidad NGiNX" title="NGiNX" />
          <img src="@/assets/images/logos/logo02_nodejs.png" alt="Habilidad Nodejs" title="NODEjs" />
          <img src="@/assets/images/logos/logo00_firebase.png" alt="Habilidad Firebase" title="Firebase" />
          <img src="@/assets/images/logos/logo00_aws.png" alt="Habilidad AWS" title="AWS" />

        </div>
      </li>

    </ul>
  </section>
</template>
<script>
export default {
  name: "page-skills",
  data() {
    return {
      msn: "Pagína Skills"
    };
  },
};
</script>

<style>
</style>
